import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/

  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },

  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: ' Part Number',
    label: 'PartNumber',
    cell: 'navigation',
    locked: true,
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceOrderLineItemId',
    field: FIELDS.SERVICE_ORDER_LINE_ITEM_ID,
    title: 'Work Order Line Item Id',
    label: 'ServiceOrderLineItemId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceOrderId',
    field: FIELDS.SERVICE_ORDER_ID,
    title: 'Work Order Id',
    label: 'ServiceOrderId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ServiceOrderLineId',
    field: FIELDS.SERVICE_ORDER_LINE_ID,
    title: 'Work Order Line Id',
    label: 'ServiceOrderLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesOrderId',
    field: FIELDS.SALES_ORDER_ID,
    title: ' Sales Order Id',
    label: 'SalesOrderId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesOrderLineId',
    field: FIELDS.SALES_ORDER_LINE_ID,
    title: ' Sales Order Line Id',
    label: 'SalesOrderLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'StatusId',
    field: FIELDS.STATUS_ID,
    title: ' Status Id',
    label: 'StatusId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'StatusName',
    field: FIELDS.STATUS_NAME,
    title: ' Status Name',
    label: 'StatusName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyId',
    field: FIELDS.COMPANY_ID,
    title: ' Company Id',
    label: 'CompanyId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Company Name',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryId',
    field: FIELDS.INVENTORY_ID,
    title: ' Inventory Id',
    label: 'InventoryId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Quantity',
    field: FIELDS.QUANTITY,
    title: ' Quantity',
    label: 'Quantity',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Total',
    field: FIELDS.TOTAL,
    title: ' Total',
    label: 'Total',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartId',
    field: FIELDS.PART_ID,
    title: ' Part Id',
    label: 'PartId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorPN',
    field: FIELDS.VENDOR_PN,
    title: ' Vendor PN',
    label: 'VendorPN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: ' Alt Number',
    label: 'AltNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InternalPN',
    field: FIELDS.INTERNAL_PN,
    title: ' Internal PN',
    label: 'InternalPN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: ' NSNNumber',
    label: 'NSNNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'HarmonizedCode',
    field: FIELDS.HARMONIZED_CODE,
    title: ' Harmonized Code',
    label: 'HarmonizedCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: ' SKU',
    label: 'SKU',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ManufacturerId',
    field: FIELDS.MANUFACTURER_ID,
    title: ' Manufacturer Id',
    label: 'ManufacturerId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'MfgName',
    field: FIELDS.MFG_NAME,
    title: ' Mfg Name',
    label: 'MfgName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryClassId',
    field: FIELDS.INVENTORY_CLASS_ID,
    title: ' Inventory Class Id',
    label: 'InventoryClassId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: ' Class Name',
    label: 'ClassName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryCategoryId',
    field: FIELDS.INVENTORY_CATEGORY_ID,
    title: ' Inventory Category Id',
    label: 'InventoryCategoryId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: ' Category Name',
    label: 'CategoryName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PackageId',
    field: FIELDS.PACKAGE_ID,
    title: ' Package Id',
    label: 'PackageId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: ' Package',
    label: 'Package',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: ' Piece Per Pkg',
    label: 'PiecePerPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PhysPkg',
    field: FIELDS.PHYS_PKG,
    title: ' Phys Pkg',
    label: 'PhysPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: ' Lead Free',
    label: 'LeadFree',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: ' Temp Rating',
    label: 'TempRating',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UoMId',
    field: FIELDS.UO_MID,
    title: ' Uo MId',
    label: 'UoMId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: ' UOM',
    label: 'UOM',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: ' Date Code',
    label: 'DateCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: ' Lot Code',
    label: 'LotCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: ' Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionId',
    field: FIELDS.CONDITION_ID,
    title: ' Condition Id',
    label: 'ConditionId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ConditionName',
    field: FIELDS.CONDITION_NAME,
    title: ' Condition Name',
    label: 'ConditionName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryOfOriginId',
    field: FIELDS.COUNTRY_OF_ORIGIN_ID,
    title: ' Country Of Origin Id',
    label: 'CountryOfOriginId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: ' Country Of Origin Name',
    label: 'CountryOfOriginName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceItemTypeId',
    field: FIELDS.SERVICE_ITEM_TYPE_ID,
    title: ' Service Item Type Id',
    label: 'ServiceItemTypeId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ServiceTypeName',
    field: FIELDS.SERVICE_TYPE_NAME,
    title: ' Service Type Name',
    label: 'ServiceTypeName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceOrderLineItemQuantity',
    field: FIELDS.SERVICE_ORDER_LINE_ITEM_QUANTITY,
    title: 'Work Order Line Item Quantity',
    label: 'ServiceOrderLineItemQuantity',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceOrderLineItemCost',
    field: FIELDS.SERVICE_ORDER_LINE_ITEM_COST,
    title: 'Work Order Line Item Cost',
    label: 'ServiceOrderLineItemCost',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceOrderLineItemTotal',
    field: FIELDS.SERVICE_ORDER_LINE_ITEM_TOTAL,
    title: 'Work Order Line Item Total',
    label: 'ServiceOrderLineItemTotal',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'POLineComments',
    field: FIELDS.POLINE_COMMENTS,
    title: ' POLine Comments',
    label: 'POLineComments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'POLineQuantity',
    field: FIELDS.POLINE_QUANTITY,
    title: ' POLine Quantity',
    label: 'POLineQuantity',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PurchaseOrderLineId',
    field: FIELDS.PURCHASE_ORDER_LINE_ID,
    title: ' Purchase Order Line Id',
    label: 'PurchaseOrderLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: '',
    title: ' ',
    cell: '',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  /*{
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
]

export default defaultFields;
